"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "montaione": {
    "f6022cd2": [{
      "hkey": "ed6f738f",
      "slug": "montaione",
      "name": "Montaione",
      "primary": true,
      "skipSearch": false
    }],
    "barbialla": [{
      "hkey": "ed6f738f",
      "slug": "montaione",
      "name": "Montaione",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "2c51d528": [{
      "hkey": "ed6f738f",
      "slug": "montaione",
      "name": "Montaione",
      "primary": true,
      "skipSearch": false
    }],
    "torri": [{
      "hkey": "ed6f738f",
      "slug": "montaione",
      "name": "Montaione",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;